import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AuthFacade } from '../../../Facades/auth.facade';

export const authGuard: CanActivateFn = (route, state) => {
  const authFacade = inject(AuthFacade);
  const router = inject(Router);

  return authFacade.initializeAuth().pipe(
    map(isAuthenticated => {
      if (isAuthenticated) {
        return true;
      }

      authFacade.setReturnUrl(state.url);
      return router.createUrlTree(['/login']);
    }),
  );
};
